import script from "./SellerClaimsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SellerClaimsPage.vue?vue&type=script&setup=true&lang=ts"

import "./SellerClaimsPage.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__